import { toast } from "react-toastify";

type EnsurePdfUrlParams = {
  dataOrdenCompra: any;
  updateOrdenesCompra: (params: any) => Promise<any>;
};

export const ensurePdfUrl = async ({
  dataOrdenCompra,
  updateOrdenesCompra,
}: EnsurePdfUrlParams) => {
  
  // Validación de seguridad
  if (!dataOrdenCompra?.data) {
    toast.error("No hay datos de la orden de compra.");
    return null;
  }

  let url = dataOrdenCompra?.data?.url_pdf;

  // Caso rápido: ya existe PDF
  if (url) return url;

  // Obtener ID de la orden
  const idOC = dataOrdenCompra?.data?.id_orden_compra;

  if (!idOC) {
    toast.error("La orden no tiene un ID válido.");
    return null;
  }

  // Generar la URL del PDF
  const result = await updateOrdenesCompra({
    id: idOC,
    data: { url_pdf: null },
    skipLoading: true,
  });

  if (!result || result.code !== 200) {
    toast.error("No se pudo generar el PDF.");
    return null;
  }

  url = result.data?.url_pdf;

  if (!url) {
    toast.error("No dispone ningún PDF de la orden.");
    return null;
  }

  return url;
};
